enum ProjectStackEnum {
  ECS = 'ecs',
  EKS = 'eks',
}

export default ProjectStackEnum
